(function (o) {

	o.track = function (topic, count) {
		var url = '/track/' + (topic || '');

        //not used, remove
		//count && (url += '/' + count);
		//$.ajax({ url: url });
	};

})(Origin);